module.exports = __webpack_public_path__ + "img/pw.386e485c.jpg";